export type TopicStatsSortMode = 'display' | 'views' | 'redemptions';

type TopicWithStats = {
  view_count: number;
  redeem_count: number;
};

export function sortAdminTopicsByMetric<T extends TopicWithStats>(
  topics: readonly T[],
  mode: TopicStatsSortMode,
): T[] {
  if (mode === 'display') return [...topics];

  const field = mode === 'views' ? 'view_count' : 'redeem_count';
  return [...topics].sort((left, right) => right[field] - left[field]);
}
